import { BsCheckCircle, BsXCircle, BsQuestionCircle } from "react-icons/bs";
import { ReactComponent as UnknownCheckedIcon } from "../../../../assets/utils/images/svgs/check-with-yellow-circle.svg";
import { ReactComponent as RoosterIcon } from "../../../../assets/utils/images/svgs/Rooster.svg";
import { ReactComponent as DagdeelIcon } from "../../../../assets/utils/images/svgs/Dagdelen.svg";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Use the plugin
dayjs.extend(customParseFormat);

export const sortOptions = [
	{
		name: "Naam",
		value: 1,
	},
	{
		name: "Afstand",
		value: 2,
	},
	{
		name: "Leeftijd",
		value: 3,
	},
	{
		name: "Beschikbaarheid",
		value: 4,
	},
];

export const allOptions = [
	{
		value: "+",
	},

	{
		value: "-",
	},
	{
		value: "+!",
	},
	{
		value: "!",
	},
	{
		value: "N",
	},
];

export const limitedOptions = [
	{
		value: "N",
	},
	{
		value: "+",
	},
];

export function generateMatchOptions() {
	const options = [];

	options.push({
		value: "",
		label: "N",
	});

	for (let i = 1; i <= 20; i++) {
		options.push({
			value: `${i}`,
			label: `${i}`,
		});
	}

	options.push({
		value: "99",
		label: "99",
	});

	return options;
}

export const getNextOption = (currentValue, options) => {
	const index = options.findIndex((i) => i.value === currentValue);
	const nextIndex = (index + 1) % options.length;
	return options[nextIndex]?.value;
};

export const availabilityOptions = [
	{
		value: "N",
		label: "N",
		icon: "N",
	},
	{
		value: "+",
		label: (
			<div className="d-flex gap-2 align-items-center">
				<BsCheckCircle color="#3AC47D" fontSize={"16px"} /> Beschikbaar
			</div>
		),
		icon: <BsCheckCircle color="#3AC47D" fontSize={"16px"} />,
	},
	{
		value: "!",
		label: (
			<div className="d-flex gap-2 align-items-center">
				<BsQuestionCircle color="#FFA500" fontSize={"16px"} /> Geen keuze gemaakt
			</div>
		),
		icon: <BsQuestionCircle color="#FFA500" fontSize={"16px"} />,
	},
	{
		value: "+!",
		label: (
			<div className="d-flex gap-2 align-items-center">
				<UnknownCheckedIcon /> Beschikbaar / geen keuze gemaakt
			</div>
		),
		icon: <UnknownCheckedIcon />,
	},
];

export const availabilityTypeOptions = [
	{
		value: "dagdelen",
		label: (
			<div className="d-flex gap-2 justify-content-center align-items-center">
				<DagdeelIcon /> Dagdelen
			</div>
		),
		icon: <DagdeelIcon />,
	},
	{
		value: "rooster",
		label: (
			<div className="d-flex gap-2 justify-content-center align-items-center">
				<RoosterIcon />
				Rooster
			</div>
		),
		icon: <RoosterIcon />,
	},
];

export const getDateCell = (date) => {
	if (!date || !date.date) return "-";
	const weekday = dayjs(date.date, "DD-MM-YYYY").format("dddd") ?? "-";

	return (
		<div className="text-capitalize">
			{weekday}, {date.date} <div className="text-lowercase">{date.shift}</div>
		</div>
	);
};

export function generateKmOptions() {
	const options = [];

	options.push({
		value: "",
		label: "N",
	});

	for (let i = 5; i <= 50; i += 5) {
		options.push({
			value: `${i}`,
			label: `${i}`,
		});
	}

	for (let i = 60; i <= 100; i += 10) {
		options.push({
			value: `${i}`,
			label: `${i}`,
		});
	}

	return options;
}
